import { Box, Flex, HStack, Table, TableContainer, Tbody, Text, Th, Thead, Tr, useDisclosure } from '@chakra-ui/react'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { AiOutlinePlus } from 'react-icons/ai'
import AttachmentModal from '../Components/AttachmentModal'
import CreateSRAModal from '../Components/CreateSRAModal'
import MoreSRA from '../Components/MoreSRA'
import Pagination from '../Components/Pagination'
import PendingIQA from '../Components/PendingIQA'
import Preloader from '../Components/Preloader'
import TableRow from '../Components/TableRow'
import MainLayout from '../Layouts/Index'
import { GetAllPendingSRA, GetAllSRA } from '../Utils/ApiCalls'
import Seo from '../Utils/Seo'
import { configuration } from '../Utils/config'

export default function QualityInspection() {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [SraID, setSraID] = useState("");

  const [Data, setData] = useState([]);

  const [CurrentPage, setCurrentPage] = useState(1);
  const [PostperPage, setPostperPage] = useState(configuration.sizeperpage);
  const [PreLoader, setPreLoader] = useState(true);


  //get current post

  const indexOfLastSra = CurrentPage * PostperPage;
  const indexOfFirstSra = indexOfLastSra - PostperPage;
  const currentData = Data.slice(indexOfFirstSra, indexOfLastSra);
  //change page 
  const paginate = (pageNumber) => {
      setCurrentPage(pageNumber)
  }


  const [OpenModal, setOpenModal] = useState(false);
  const [SIngleData, setSIngleData] = useState([]);

  const openSra = (id)=>{
    onOpen()
    setSraID(id)
  }

    const ViewAttachment = (id)=>{
    let singleData = Data.filter(item => item._id === id)
    setSIngleData(singleData)
    setOpenModal(true)
   
  }
 

  const AllSRA = async () => {
    let result = await GetAllPendingSRA()

    console.log("object sra", result);

    if (result.status == true) {
        setData(result.queryresult.sraproductdetails
          )
          setPreLoader(false)
    }
}
  moment.locale("en-gb");        

useEffect(() => {
  AllSRA()

}, [isOpen]);
  return (
   <MainLayout>
   {
                PreLoader && (

                    <Preloader/>
                )
            }
    <Seo title="Quality Inspection" description='IMS Quality Inspection '/> 

  <Flex justifyContent={"flex-end"} flexWrap="wrap" fontWeight={"500"}>


<Text textTransform="Capitalize" >Total Pending I&QA- {Data?.length}</Text>
  </Flex>


  <Box display={"block"} alignItems="flex-start" w={"100%"} height="70vh" minH={"70vh"} overflow="auto" _hover={{overflow: "auto"}} bg="blue.blue200" mt="32px" rounded={"8px"}>
            
            <TableContainer w={"100%"} mt="32px" overflowX="auto" color="#fff"
     
            >
              <Table variant='simple' size='sm' overflowX="auto" >
                <Thead>
                  <Tr>
                    <Th color="#fff">S/N</Th>
                    <Th color="#fff">Product Name</Th>
                    <Th color="#fff"> Product shelf id</Th>
                     <Th color="#fff"> IIR Number</Th>
                    <Th color="#fff">Date received</Th>
                    <Th color="#fff">Qty inspected</Th>
                    <Th color="#fff">See Attachment</Th>
                    <Th color="#fff">Action</Th> 
                    
                  </Tr>
                </Thead>
                <Tbody>
      
                {
                  currentData.map((item,i)=>(
                    <TableRow
                    type="pendingSra"
                    sn={i + 1}
                    productName={item.shelfid.productname}
                    productShelfId={item.shelfid.productshelfid}
                    itemNo={item.sra?.itemnos}
                    dateReceived={moment(item.datereceived).format('DD/MM/YYYY')}
                    qtyinspected={item.qtyinspected}
                    viewAtt={()=>ViewAttachment(item._id)}
                    onClick={()=>openSra(item._id)}
        
                    />
                  ))
                }

              
                </Tbody>
      
              </Table>
            </TableContainer>

            <Pagination postPerpage={PostperPage} currentPage={CurrentPage} totalPosts={Data.length} paginate={paginate} />
         

            </Box>

<PendingIQA isOpen={isOpen} onClose={onClose} id={SraID} state="certifySra"/>
<AttachmentModal singleData={SIngleData} isOpen={OpenModal} onClose={()=>setOpenModal(false)}/>

   </MainLayout>
  )
}

